import { gql, useMutation } from 'urql';

const SEND_REGISTRATION_LINKS = gql`
  mutation SendRegistrationLinks($input: SendRegistrationLinksInput!) {
    sendRegistrationLinks(input: $input) {
      queued
      skipped
      alreadyRegistered
      unavailable
      attempt
    }
  }
`;
export interface RegistrationLinksInput {
  eventId: number;
  formId: number;
  ticketIds: number[];
  channels: string[];
  message: string;
  emailSubject: string | null;
  emailMessage: string | null;
}
export const useSendRegistrationLinks = () =>
  useMutation<
    {
      sendRegistrationLinks: {
        queued: number;
        skipped: number;
        alreadyRegistered: number;
        unavailable: number;
        attempt: number;
      };
    },
    { input: RegistrationLinksInput }
  >(SEND_REGISTRATION_LINKS);
